<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalFormComponent from '@/components/partner/ModalFormComponent.vue';
import ModalTableComponentPays from '@/components/pays/ModalTableComponent.vue';
import ModalFormRulesComponent from '@/components/partner/ModalFormRulesComponent.vue';
import ModalFormTaxesComponent from '@/components/partner/ModalFormTaxesComponent.vue';
import ModalPayCheckbookFastComponent from '@/components/pays/ModalPayCheckbookFastComponent.vue';
import ModalPayGroupCheckbookFastComponent from '@/components/pays/ModalPayGroupCheckbookFastComponent.vue';
import ModalDownloadFileComponent from '@/components/partner/ModalDownloadFileComponent.vue';
import Catalogue from '@/services/catalogue';

import LoadPay from '@/components/LoadPayPageComponent.vue';

import Pagination from 'vue-pagination-2';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "partner-table",
	components: {
		ModalFormComponent,
		ModalFormRulesComponent,
		ModalFormTaxesComponent,
		ModalTableComponentPays,
		ModalPayCheckbookFastComponent,
		ModalPayGroupCheckbookFastComponent,
		ModalDownloadFileComponent,
		LoadPay,
		DatePicker,
		Pagination,
	},
	data() {
		return {
			console:console,
			Arrauthorized: [],
			sendGroup: false,
			loadAll: false,
			shares: [],
			partners: [],
			checks: [],
			shares_p: [],
			partners_p: [],
			checks_p: [],
			shares_s: [],
			partners_s: [],
			checks_s: [],
			name: '',
			editShare: true,
			trigger:true,
			init:false,
			search: {
				date: '',
				company_id: '',
				paid : 0,
				user_id : '',
				type_payment_id: '',
				share:1,
				authorized:1
			},
			order:{
				id:-1,
				name:-1,
				amount:-1,
				paid:-1,
				retention:-1,
				date:0,
				approved:-1,
			},
			view : 1,
			idConvert: '',
			idUser: '',
			page: 1,
			per_page: 10,
			send: false,
			catalogue: new Catalogue(),
			load: false,
			isExpanded: []
		}
	},
	async mounted() {
		this.loadAll = true;

		if(!this.authUser.profile.permissions.some(permission => permission.permission=='view_created')){ 
			this.search.authorized = 0
		}
		this.list();
		if((this.authUser.organization_charts_id == 10 && this.authUser.id!=1123)|| this.authUser.organization_charts_id == 15){ 
            await this.catalogue.get_companies_users(this.authUser.id);
        }else{
            await this.catalogue.get_companies_buildings();
        }

		await this.catalogue.get_users_profile(8);
        await this.catalogue.get_type_payments_partners();

		this.setHeaderTitle('Socios');
		this.loadAll = false;
	},
	created() {
		Event.$on("event-load-checks-shares", () => {
			this.list();
		});
		Event.$on('event-load-checks', () => {
			this.list();
		});
	},
	methods: {
		approve(obj) {
			let tit = 'Aprobar Reparto';
			let txt = 'Seguro que quiere aprobar el reparto de dividendos';
			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint,form;
					if(this.view==1){
						_endpoint = '/partners/share_approve';
						form = {
							id: obj.id
						};
					}else{
						_endpoint = '/partners/share_partner_approve';
						form = {
							user_id: obj.user_id,
							share_id: obj.share_id,
						}
					}
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						this.successNotification(response.data.message);
						Event.$emit('event-load-checks-shares');
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});

		},
		async newShare(account = {}, edit = true) {
			this.editShare = edit;
			Event.$emit('event-show-addShare', account, edit);
		},
		async editRules() {
			Event.$emit('event-show-editRules');
		},		
		async editTaxes() {
			Event.$emit('event-show-editTaxes');
		},
		paymentConditions() {
			return (this.view==1 && this.search.authorized==1 && this.shares_s && this.shares_s.length > 0) ||
				(this.view!=1 && this.search.authorized==1 && this.partners_s && this.partners_s.length > 0) ||
				(this.search.company_id != '' &&
				(
					this.search.date == '' ||
					this.search.date[0]==null
				) &&
				this.search.user_id == '' &&
				this.search.type_payment_id == '' &&
				(this.checks_s && this.checks_s.length > 0 && this.search.paid==0))
		},
		paymentConditionsCheck() {
			return this.search.company_id != '' &&
				this.search.type_payment_id == 6 &&
				this.search.user_id == '' &&
				(
					this.search.date == '' ||
					this.search.date[0] == null
				) &&
				(
					(this.shares_s && this.shares_s.length > 0) ||
					(this.checks_s && this.checks_s.length > 0 && this.search.paid==0)
				)
		},
		async formDataPayFast(check) {
			let company_id = check.share.company_id;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						check_id: check.id,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
					};
					let _endpoint = '/partners/pay_share';
					try {
						let { data } = await request.post(_endpoint, form)
						if (data) {
							this.successNotification(data.message);
							Event.$emit('event-load-checks-shares');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {
				this.$swal({
					title: 'Pago rápido',
					html: 'Se aprobará el pago rápido<br><br><input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							check_id: check.id,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
						};
						let _endpoint = '/partners/pay_share';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								this.successNotification(data.message);
								Event.$emit('event-load-checks-shares');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}

		},
		async formDataPaysFastCheckbook(check) {
			Event.$emit('event-show-addPayCheckbookFast', check);
		},
		formListPays(check) {
			Event.$emit('event-show-listPays', check);
		},
		async formDataApproveGroup() {
			let Arrauthorized = this.Arrauthorized, form, _endpoint;
			// console.log(Arrauthorized);
			this.sendGroup = true;
			if(this.view==1){
				form = {
					shares_id: Arrauthorized,
					description: 'Repartos Aprobados'
				};
				_endpoint = '/shares_group';
			}else{
				form = {
					partners: Arrauthorized,
					description: 'Repartos Aprobados'
				};
				_endpoint = '/shares_partners_group';
			}
			try {
				let { data } = await request.postMedia(_endpoint, form)
				if (data) {
					this.successNotification(data.message);
					Event.$emit('event-load-checks-shares');
					this.sendGroup = false;
				}
			} catch (error) {
				this.errors = {};
				if (error.response) {
					this.errors = await this.errorNotification(error);
					this.sendGroup = false;
				}
			}
		},
		async formDataPaysFastGroup() {
			let company_id = this.search.company_id;
			let Arrauthorized = this.Arrauthorized;
			await this.catalogue.getBankAccountCompany(company_id);
			let bancks = this.catalogue.bank_account_company;
			let banco = [];
			bancks.forEach(function (bank) {
				let name = '';
				if (bank.bank) {
					name += bank.bank.name + ' - ';
				}
				name += bank.number;
				banco['_' + bank.id] = name;
			});

			if (bancks.length == 0) {
				this.$swal({
					title: "No se cuenta con cuenta",
					text: "No se puede pagar es requerida una cuenta",
					icon: "info"
				});
			}

			if (bancks.length > 1) {
				const { value: bank_id } = await this.$swal({
					title: "Cuenta de banco",
					html: '<div class="col-12"><input type="date" id="input_date_12" class="form-control"></div>',
					input: "select",
					inputOptions: banco,
					inputPlaceholder: "Seleccione una cuenta de banco",
					showCancelButton: true,
					inputValidator: (value) => {
						return new Promise((resolve) => {
							let date = document.getElementById('input_date_12').value;
							if (value !== "" && date !== "") {
								resolve();
							} else {
								if (value == "") {
									resolve("Es requerida la cuenta de banco");
								} else {
									resolve("Es requerida la fecha");
								}
							}
						});
					}
				});

				if (bank_id) {
					this.$modal.show('LoadPay');
					this.sendGroup = true;
					let form = {
						checks_id: Arrauthorized,
						bank_id: bank_id.substring(1),
						date: document.getElementById('input_date_12').value,
						description: 'Pago aprobado'
					};
					let _endpoint = '/pays_group';
					try {
						let { data } = await request.postMedia(_endpoint, form)
						if (data) {
							this.successNotification(data.message);
							Event.$emit('event-load-checks-shares');
							this.sendGroup = false;

						}
					} catch (error) {
						this.errors = {};
						if (error.response) {
							this.errors = await this.errorNotification(error);
							this.sendGroup = false;
						}
					}
					this.$modal.hide('LoadPay');
				}
			} else {

				this.$swal({
					title: 'Pago rápido',
					text: 'Se aprobara el pago rápido',
					html: '<input type="date" id="input_date_2" class="form-control">',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Pagar',
					cancelButtonText: 'Cancelar'
				}).then(async (result) => {
					if (result.isConfirmed) {
						this.$modal.show('LoadPay');
						this.sendGroup = true;
						let form = {
							checks_id: Arrauthorized,
							bank_id: bancks[0].id,
							date: document.getElementById('input_date_2').value,
							description: 'Pago aprobado'
						};
						let _endpoint = '/pays_group';
						try {
							let { data } = await request.postMedia(_endpoint, form)
							if (data) {
								this.successNotification(data.message);
								Event.$emit('event-load-checks-shares');
								this.sendGroup = false;
							}
						} catch (error) {
							this.errors = {};
							if (error.response) {
								this.errors = await this.errorNotification(error);
								this.sendGroup = false;

							}
						}
						this.$modal.hide('LoadPay');
					}
				});
			}
		},
		formDataPaysFastGroupCheck() {
			Event.$emit('event-show-showPayGroupCheckbookFast', this.search, this.checks_s);
		},
		exportData() {
			// Event.$emit('event-show-downloadFile');
			let filter = this.search;
			filter.type = 'bill';
			filter.user_logged = this.authUser.id;

			let data = new URLSearchParams(filter).toString();

            let _url = this.globalUrlFiles + '/partners/shares/export?'+data;            
			window.open(_url, '_blank');
		},
		downloadPDF(id) {
			let filter = this.globalUrlFiles + '/shares/'+id+'/pdf';
			window.open(filter, '_blank');
		},
		deleted: function (obj) {
			if(this.search.authorized==1){
				let tit = 'Eliminar Reparto';
				let txt = 'Seguro que quiere eliminar el reparto de dividendos';

				this.$swal({
					title: tit,
					text: txt,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
					cancelButtonText: 'Cancelar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.callDeleted(obj.id);
					}
				});
			}else{
				let tit = 'Desaprobar reparto';
				let txt = 'Seguro que quiere desaprobar el reparto de dividendos';

				this.$swal({
					title: tit,
					text: txt,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Ok',
					cancelButtonText: 'Cancelar'
				}).then((result) => {
					if (result.isConfirmed) {
						this.callDeleted(obj.id);
					}
				});
			}
		},
		async callDeleted(id) {
			if(this.search.authorized==1){
				let _endpoint = 'shares/' + id;
				try {
					let response = await request.destroy(_endpoint).then(function (response) { return response; });
					this.list();
					this.successNotification(response.data.message);
				} catch (error) {
					this.errors = await this.errorNotification(error)
				}
			}else{
				let _endpoint = '/checks/' + id;
				try {
					let response = await request.destroy(_endpoint).then(function (response) { return response; });
					Event.$emit('event-load-checks-shares');
					this.successNotification(response.data.message);
				} catch (error) {
					this.errors = await this.errorNotification(error)
				}
			}
		},
		sumdata() {
			let sum = 0;
			let sum1 = 0;
			let sum2 = 0;
			let sum3 = 0;

			if (this.shares_s.length>0) {
				this.shares_s.forEach(function (share) {
					sum += parseFloat(share.amount??0);
					sum1 += parseFloat(share.checks_sum_amount??0);
					sum2 += parseFloat(share.pays_sum_amount??0);
				});
				return sum;
			}

			if (this.checks_s.length>0) {
				this.checks_s.forEach(function (buy) {
					if (buy.amount) {
						sum1 += parseFloat(buy.amount);
					}
					if (buy.credit) {
						sum1 += parseFloat(buy.credit);
					}
					sum2 += parseFloat(buy.amount_payable);
					sum3 += parseFloat(buy.sum_pays);

				});
				return [sum1, sum2, sum3];
			}
			if (this.partners.length>0) {
				this.partners_s.forEach(function (p) {
					if (p.amount) {
						sum1 += parseFloat(p.amount);
					}
					sum2 += parseFloat(p.retention);
				});
				return [sum1, sum2];
			}
		},
		getVoucher(id) {
			window.open(this.globalUrlFiles + '/voucherPay/' + id, '_blank');
		},
		selectAll() {
			this.Arrauthorized = [];
			let selected = this.Arrauthorized;
			if(this.view==1){
				this.shares_s.forEach(element => {
					if (!selected.includes(element.id)) {
						selected.push(element.id);
					}
				});
			}else if(this.search.authorized!=1){
				let vm=this;
				this.checks_s.forEach(element => {
					if (!selected.includes(element.id)&&((vm.search.type_payment_id!=6&&element.type_payment_id!=6) || (vm.search.type_payment_id==6&&element.type_payment_id==6))) {
						selected.push(element.id);
					}
				});
			}else
				this.partners_s.forEach(element => {
					let obj={
						user_id: element.user_id,
						share_id: element.share_id,
					};
					if (!selected.includes(obj)) {
						selected.push(obj);
					}
				});
			this.Arrauthorized = selected;
			// console.log(this.Arrauthorized);

		},
		deselectAll() {
			this.Arrauthorized = [];
		},
		async changePage(page = 1){
			if(this.view==1)
				this.shares_s=this.shares_p[page-1];
			else if (this.search.authorized==0)
				this.checks_s=this.checks_p[page-1];
			else
				this.partners_s=this.partners_p[page-1];
		},
		async sortPage(name){
			switch(name){
				case 'id':
					this.order.id++;
					if(this.order.id%2==0)
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return a.id - b.id
							});
						else
							this.checks=this.checks.sort((a,b)=>{
								return a.id - b.id
							});
					else
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return b.id - a.id
							});
						else
							this.checks=this.checks.sort((a,b)=>{
								return b.id - a.id
							});
					this.order.name=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'name':
					this.order.name++;
					if(this.order.name%2==0)
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return a.company.name.localeCompare(b.company.name)
							});
						else if (this.search.authorized==0){
							this.checks=this.checks.sort((a,b)=>{
								return a.user.name.localeCompare(b.user.name)
							});
							this.checks=this.checks.sort((a,b)=>{
								return a.share.company.name.localeCompare(b.share.company.name)
							});
						}else{
							this.partners=this.partners.sort((a,b)=>{
								return a.user.name.localeCompare(b.user.name)
							});
							this.partners=this.partners.sort((a,b)=>{
								return a.share.company.name.localeCompare(b.share.company.name)
							});
						}
					else
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return b.company.name.localeCompare(a.company.name)
							});
						else if (this.search.authorized==0){
							this.checks=this.checks.sort((a,b)=>{
								return b.user.name.localeCompare(a.user.name)
							});
							this.checks=this.checks.sort((a,b)=>{
								return b.share.company.name.localeCompare(a.share.company.name)
							});
						}else{
							this.partners=this.partners.sort((a,b)=>{
								return b.user.name.localeCompare(a.user.name)
							});
							this.partners=this.partners.sort((a,b)=>{
								return b.share.company.name.localeCompare(a.share.company.name)
							});
						}
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'amount':
					this.order.amount++;
					if(this.order.amount%2==0)
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return a.amount- b.amount
							});
						else if (this.search.authorized==0)
							this.checks=this.checks.sort((a,b)=>{
								return a.amount- b.amount
							});
						else
							this.partners=this.partners.sort((a,b)=>{
								return a.amount - b.amount
							});
					else
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return b.amount- a.amount
							});
						else if (this.search.authorized==0)
							this.checks=this.checks.sort((a,b)=>{
								return b.amount- a.amount
							});
						else
							this.partners=this.partners.sort((a,b)=>{
								return b.amount - a.amount
							});
					this.order.id=-1;
					this.order.name=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'paid':
					this.order.paid++;
					if(this.order.paid%2==0)
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return (a.pays_sum_amount??0)- (b.pays_sum_amount??0)
							});
						else 
							this.checks=this.checks.sort((a,b)=>{
								return a.sum_pays- b.sum_pays
							});
					else
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return (b.pays_sum_amount??0)- (a.pays_sum_amount??0)
							});
						else 
							this.checks=this.checks.sort((a,b)=>{
								return b.sum_pays- a.sum_pays
							});
					this.order.id=-1;
					this.order.name=-1;
					this.order.amount=-1;
					this.order.retention=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'retention':
					this.order.retention++;
					if(this.order.retention%2==0)
						this.partners=this.partners.sort((a,b)=>{
							return a.retention - b.retention
						});
					else
						this.partners=this.partners.sort((a,b)=>{
							return b.retention - a.retention
						});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.name=-1;
					this.order.date=-1;
					this.order.approved=-1;
				break;
				case 'date':
					this.order.date++;
					if(this.order.date%2==0)
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return new Date(a.date) - new Date(b.date)
							});
						else if (this.search.authorized==0)
							this.checks=this.checks.sort((a,b)=>{
								return new Date(a.share.date) - new Date(b.share.date)
							});
						else
							this.partners=this.partners.sort((a,b)=>{
								return new Date(a.share.date) - new Date(b.share.date)
							});
					else
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return new Date(b.date) - new Date(a.date)
							});
						else if (this.search.authorized==0)
							this.checks=this.checks.sort((a,b)=>{
								return new Date(b.share.date) - new Date(a.share.date)
							});
						else
							this.partners=this.partners.sort((a,b)=>{
								return new Date(b.share.date) - new Date(a.share.date)
							});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.approved=-1;
				break;
				case 'approved':
					this.order.approved++;
					if(this.order.approved%2==0)
						if(this.view==1){
							this.shares=this.shares.sort((a,b)=>{
								return (a.checks_sum_amount??0) - (b.checks_sum_amount??0)
							});
						}else 
							this.checks=this.checks.sort((a,b)=>{
								return new Date(a.authorization_date) - new Date(b.authorization_date)
							});
					else
						if(this.view==1)
							this.shares=this.shares.sort((a,b)=>{
								return (b.checks_sum_amount??0) - (a.checks_sum_amount??0)
							});
						else 
							this.checks=this.checks.sort((a,b)=>{
								return new Date(b.authorization_date) - new Date(a.authorization_date)
							});
					this.order.id=-1;
					this.order.amount=-1;
					this.order.paid=-1;
					this.order.retention=-1;
					this.order.name=-1;
					this.order.date=-1;
				break;
			}
		},
		async list() {
			this.order={
				id:-1,
				name:-1,
				amount:-1,
				paid:-1,
				retention:-1,
				date:0,
				approved:-1,
			};
			this.init=false;
			this.load = true;
			this.shares=[];
			this.checks=[];
			this.partners={};
			this.page=1;
			let service = request;
			let search = this.search, _endpoint='';
			if(this.view==1){
				_endpoint = '/shares';
			}else if(this.search.authorized!=1){
				_endpoint = '/pays';
			}else{
				_endpoint = '/shares_users';
			}
			search.search = this.name;
			try {
				let { data } = await service.list(_endpoint,this.page, search)
				if (data) {

					this.init=this.search.company_id == '' &&
					this.search.type_payment_id == '' &&
					this.search.user_id == '' &&
					(this.search.date == '' || this.search.date[0]==null);
					if(this.view==1){
						this.shares = data.data;
					}else if(this.search.authorized!=1){
						this.checks = data.data;
					}else{
						this.partners=data.data;
					}
					this.sortPage('date');
					if(data.dates[0]!=''){
						this.trigger=false;
						this.search.date = data.dates;
					}
					this.load = false;
					this.Arrauthorized = [];
				}
			} catch (error) {
				console.log(error);
				this.load = false;

			}
			this.Load=false;
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'shares': {
			handler: function () {
				if(this.shares.length>0){
					let vm=this,k=0,j=1;
					this.shares_p=[];
					this.shares_p[0]=[];
					this.shares.forEach(s=>{
						vm.shares_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.shares_p[k]=[];
						}
						j++;

					});
					this.shares_s=this.shares_p[this.page-1];
				}else{
					this.shares_p=[];
					this.shares_s=[];
				}
			},
			deep: true
		},
		'checks': {
			handler: function () {
				if(this.checks.length>0){
					let vm=this,k=0,j=1;
					this.checks_p=[];
					this.checks_p[0]=[];
					this.checks.forEach(p=>{
						vm.checks_p[k].push(p);
						if(j%vm.per_page==0){
							k++;
							vm.checks_p[k]=[];
						}
						j++;

					});
					this.checks_s=this.checks_p[this.page-1];
				}else{
					this.checks_p=[];
					this.checks_s=[];
				}
			},
			deep: true
		},
		'partners': {
			handler: function () {
				if(this.partners.length>0){
					let vm=this,k=0,j=1;
					this.partners_p=[];
					this.partners_p[0]=[];
					this.partners.forEach(p=>{
						vm.partners_p[k].push(p);
						if(j%vm.per_page==0){
							k++;
							vm.partners_p[k]=[];
						}
						j++;

					});
					this.partners_s=this.partners_p[this.page-1];
				}else{
					this.partners_p=[];
					this.partners_s=[];
				}
			},
			deep: true
		},
		'per_page': {
			handler: function () {
				this.page=1;
				if(this.shares.length>0){
					let vm=this,k=0,j=1;
					this.shares_p=[];
					this.shares_p[0]=[];
					this.shares.forEach(s=>{
						vm.shares_p[k].push(s);
						if(j%vm.per_page==0){
							k++;
							vm.shares_p[k]=[];
						}
						j++;

					});
					this.shares_s=this.shares_p[this.page-1];
				} else if(this.checks.length>0){
					let vm=this,k=0,j=1;
					this.checks_p=[];
					this.checks_p[0]=[];
					this.checks.forEach(p=>{
						vm.checks_p[k].push(p);
						if(j%vm.per_page==0){
							k++;
							vm.checks_p[k]=[];
						}
						j++;

					});
					this.checks_s=this.checks_p[this.page-1];
				}else if(this.partners.length>0){
					let vm=this,k=0,j=1;
					this.partners_p=[];
					this.partners_p[0]=[];
					this.partners.forEach(p=>{
						vm.partners_p[k].push(p);
						if(j%vm.per_page==0){
							k++;
							vm.partners_p[k]=[];
						}
						j++;

					});
					this.partners_s=this.partners_p[this.page-1];
				}
			},
			deep: true
		},
		'view': {
			handler: function () {
				this.list();
				if(this.view==1){
					this.search.user_id='';
					this.search.type_payment_id='';
				}
			},
			deep: true
		},
		'search': {
			handler: function () {
				if(this.trigger){
					this.list();
				}else
					this.trigger=true;
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<style scoped>
.shares-page {
	padding-bottom: 20px;
}

.card-header {
	padding: 16px 20px;
}

.card-title {
	font-size: 18px;
	font-weight: 600;
}

.shares-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
	align-items: center;
	justify-content: flex-end;
}

.shares-actions .btn {
	white-space: nowrap;
}

/* Filtros */

.filters-panel {
	padding: 18px 18px 3px;
	margin-bottom: 20px;
	background-color: #f8f9fa;
	border: 1px solid #e3e6e9;
	border-radius: 8px;
}

.filters-heading h6 {
	font-size: 16px;
	color: #2f343a;
}

.filters-panel label {
	margin-bottom: 6px;
	font-size: 13px;
	font-weight: 600;
	color: #495057;
}

.filters-grid {
	margin-right: -8px;
	margin-left: -8px;
}

.filters-grid > [class*="col-"] {
	margin-top: 0 !important;
	margin-bottom: 15px;
	padding-right: 8px;
	padding-left: 8px;
}

.filters-panel .form-control,
.filters-panel >>> .mx-input {
	height: 40px;
	font-size: 14px;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background-color: #ffffff;
	box-shadow: none;
}

.filters-panel .form-control:focus,
.filters-panel >>> .mx-input:focus {
	border-color: #80bdff;
	box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.08);
}

.search-input-wrapper {
	position: relative;
}

.search-input-wrapper > i {
	position: absolute;
	top: 50%;
	left: 13px;
	z-index: 2;
	color: #6c757d;
	font-size: 13px;
	transform: translateY(-50%);
	pointer-events: none;
}

.search-input-wrapper .form-control {
	padding-left: 36px;
}

.date-filter,
.date-filter >>> .mx-datepicker {
	width: 100%;
}

.default-period-badge {
	display: inline-flex;
	align-items: center;
	padding: 5px 9px;
	color: #856404;
	background-color: #fff3cd;
	border: 1px solid #ffe69c;
	border-radius: 14px;
	font-size: 11px;
	font-weight: 600;
	white-space: nowrap;
}

.complement-filter {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 40px;
	margin-top: 25px !important;
	border: 1px solid #ced4da;
	border-radius: 6px;
	background-color: #ffffff;
	color: #495057;
	font-size: 13px;
	font-weight: 600;
}

.complement-filter:hover {
	color: #0056b3;
	background-color: #f3f7fc;
	border-color: #80bdff;
}

.complement-filter.active {
	color: #0056b3;
	background-color: #e7f1ff;
	border-color: #4b72d9;
}

/* Tarjetas de resumen */

.shares-summary {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 17px;
	margin-bottom: 20px;
}

.summary-card {
	display: flex;
	align-items: center;
	min-height: 85px;
	padding: 15px;
	background-color: #ffffff;
	border: 1px solid #e5e7eb;
	border-left: 4px solid #6c757d;
	border-radius: 8px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);
}

.summary-icon {
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 0 0 44px;
	width: 44px;
	height: 44px;
	margin-right: 13px;
	font-size: 18px;
	color: #2f343a;
	background-color: #f1f3f5;
	border-radius: 50%;
}

.summary-card span {
	display: block;
	margin-bottom: 1px;
	font-size: 12px;
	color: #6c757d;
	text-transform: uppercase;
	letter-spacing: 0.3px;
}

.summary-card strong {
	display: block;
	font-size: 22px;
	line-height: 1.1;
	color: #212529;
	word-break: break-word;
}

.summary-total {
	border-left-color: #6c757d;
}

.summary-amount {
	border-left-color: #28a745;
}

.summary-pending {
	border-left-color: #ffc107;
}

.summary-paid {
	border-left-color: #4b72d9;
}

/* Tabla */

.table-container {
	overflow: hidden;
	border: 1px solid #dee2e6;
	border-radius: 8px;
}

.shares-table-wrapper {
	position: relative;
	height: clamp(420px, calc(100vh - 560px), 760px);
	min-height: 420px;
	overflow-x: auto !important;
	overflow-y: auto !important;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
}

.shares-table {
	width: 100%;
	min-width: 1320px;
	margin-bottom: 0;
	table-layout: fixed;
	border-collapse: separate;
	border-spacing: 0;
}

.shares-table thead th {
	position: sticky;
	top: 0;
	z-index: 20;
	padding: 12px 8px;
	vertical-align: middle;
	font-size: 12px;
	font-weight: 700;
	color: #343a40;
	background-color: #f1f3f5;
	border-bottom: 2px solid #d9dde1;
	text-transform: uppercase;
	box-shadow: 0 2px 0 #d9dde1;
}

.shares-table tbody td {
	padding: 11px 8px;
	vertical-align: middle;
	font-size: 12px;
	line-height: 1.45;
	background-color: #ffffff;
}

.shares-table tbody tr {
	transition: background-color 0.15s ease;
}

.shares-table tbody tr:hover td {
	background-color: #f8fafc !important;
}

.share-row td:first-child {
	border-left: 4px solid #6c757d;
}

.check-row td:first-child {
	border-left: 4px solid #6c757d;
}

.partner-row td:first-child {
	border-left: 4px solid #6c757d;
}

.data-column {
	width: 390px;
}

.amount-column {
	width: 140px;
}

.date-column {
	width: 160px;
}

.actions-column {
	width: 310px;
}

.check-column {
	width: 70px;
}

.payment-id-cell {
	font-size: 14px !important;
	font-weight: 700;
}

.payment-id {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 40px;
	min-height: 30px;
	padding: 4px 8px;
	color: #343a40;
	background-color: #f1f3f5;
	border-radius: 6px;
}

.data-cell {
	color: #495057;
}

.data-cell > span {
	display: block;
}

.data-cell strong {
	color: #2f343a;
	font-weight: 600;
}

.data-cell hr {
	margin: 9px 0;
	border-top-color: #e3e6e9;
}

.amount-cell,
.pending-cell,
.paid-cell {
	font-size: 13px !important;
	font-weight: 600;
	font-variant-numeric: tabular-nums;
	white-space: nowrap;
}

.amount-payable-cell,
.pending-cell {
	color: #856404;
}

.amount-paid-cell,
.paid-cell {
	color: #1d7a36;
}

.date-cell {
	font-size: 12px !important;
	color: #6c757d;
}

.actions-cell {
	padding: 9px !important;
}

.actions-wrap {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	align-items: center;
	justify-content: center;
}

.actions-wrap .d-inline {
	display: contents !important;
}

.actions-wrap hr {
	flex: 0 0 100%;
	width: 100%;
	margin: 3px 0;
	border-top-color: #e1e5e9;
}

.actions-wrap .btn,
.actions-wrap a.btn {
	margin: 0 !important;
	padding: 5px 8px;
	border-radius: 6px;
	/* background-color: #ffffff; */
	font-size: 11px;
	font-weight: 500;
	line-height: 1.3;
	white-space: normal;
	box-shadow: none;
}

/* .actions-wrap .btn-outline-light {
	color: #6c757d;
	border-color: #6c757d;
}

.actions-wrap .btn-outline-light:hover {
	color: #ffffff;
	background-color: #6c757d;
} */

.table-state {
	height: 250px;
	padding: 0 !important;
}

.loading-state,
.empty-state {
	padding: 50px 20px;
	text-align: center;
}

.loading-state i,
.empty-state i {
	margin-bottom: 12px;
	font-size: 36px;
	color: #adb5bd;
}

.loading-state h5,
.empty-state h5 {
	margin-bottom: 4px;
	font-size: 15px;
	font-weight: 600;
	color: #343a40;
}

.loading-state p,
.empty-state p {
	margin-bottom: 0;
	font-size: 12px;
	color: #6c757d;
}

.totals-row td {
	position: sticky;
	bottom: 0;
	z-index: 4;
	padding: 12px 8px;
	font-weight: 700;
	color: #343a40;
	background-color: #e9ecef !important;
	border-top: 2px solid #ced4da;
	font-variant-numeric: tabular-nums;
}

.pagination-wrapper {
	display: flex;
	justify-content: flex-end;
	padding: 13px 16px;
	background-color: #ffffff;
	border-top: 1px solid #dee2e6;
}

.pagination-wrapper >>> .pagination {
	margin-bottom: 0;
}

.selected td {
	background-color: #f1f5ff !important;
}

.selected td:first-child {
	border-left-color: #4b72d9;
}

/* Modal de tipo de pago */

.btn-app {
	margin: 0;
	height: 80px;
}

.f-30 {
	font-size: 30px;
}

.payment-type-modal >>> .v--modal {
	border-radius: 8px;
	overflow: visible;
}

.payment-type-modal .modal-header {
	padding: 18px 20px 8px;
	border-bottom: 0;
}

.payment-type-modal .modal-title {
	margin-bottom: 0;
	font-size: 17px;
	font-weight: 600;
}

.modal-subtitle {
	margin: 4px 0 0;
	font-size: 12px;
	color: #6c757d;
}

.payment-type-modal .modal-body {
	padding: 10px 20px 20px;
}

.payment-type-modal .btn-closed {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 4;
	width: 30px;
	height: 30px;
	padding: 0;
	border-radius: 50%;
}

.payment-option-btn {
	display: flex !important;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 7px;
	height: 90px !important;
	border: 1px solid #dee2e6;
	border-radius: 8px;
	background-color: #f8f9fa;
	color: #343a40;
	font-size: 12px;
	font-weight: 600;
}

.payment-option-btn:hover {
	color: #0056b3;
	background-color: #eef5ff;
	border-color: #80bdff;
}

/* Responsive */

@media (max-width: 1199px) {
	.shares-summary {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.shares-table-wrapper {
		height: 60vh;
		min-height: 420px;
	}
}

@media (max-width: 767px) {
	.card-header {
		padding: 14px;
	}

	.card-body {
		padding: 14px;
	}

	.shares-actions {
		width: 100%;
		justify-content: flex-start;
	}

	.filters-panel {
		padding: 15px 15px 0;
	}

	.shares-summary {
		grid-template-columns: 1fr;
		gap: 10px;
	}

	.summary-card {
		min-height: 75px;
	}

	.pagination-wrapper {
		justify-content: center;
		overflow-x: auto;
	}

	.shares-table-wrapper {
		height: 65vh;
		min-height: 400px;
	}
}

@media (max-width: 575px) {
	.shares-actions {
		display: grid;
		grid-template-columns: 1fr;
	}

	.shares-actions .btn {
		width: 100%;
	}

	.filters-heading {
		align-items: flex-start !important;
		flex-direction: column;
	}

	.default-period-badge {
		white-space: normal;
	}
}
</style>

<template>
	<div class="col-12 shares-page">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<div class="d-flex flex-wrap align-items-center justify-content-between">
					<div>
						<h3 class="card-title mb-0">
							<i class="fa-solid fa-money-check-dollar mr-2"></i>
							Lista de Repartos
						</h3>
						<br>
						<small class="text-muted d-block mt-1">
							Consulta, filtra y administra los movimientos registrados.
						</small>
					</div>
					<div class="card-tools mt-2 mt-md-0 shares-actions">
						<button @click="editTaxes()" v-can="'edit_rules'" class="btn btn-sm btn-outline-secondary mr-1">
							Tarifas
						</button>
						<button @click="editRules()" v-can="'edit_rules'" class="btn btn-sm btn-outline-info mr-1">
							Reglas
						</button>
						<button @click="newShare()" v-can="'add_share'" class="btn btn-sm btn-outline-primary">
							<i class="fa fa-plus"></i> Reparto
						</button>
					</div>
				</div>
			</div>
			<div class="card-body">
				<section class="filters-panel">
					<div class="d-flex align-items-center justify-content-between mb-3 filters-heading">
						<h6 class="mb-0 font-weight-bold">
							<i class="fa-solid fa-filter mr-1"></i>
							Filtros
						</h6>

						<span v-if="init" class="default-period-badge">
							<i class="fa-regular fa-calendar mr-1"></i>
							Periodo predeterminado
						</span>
					</div>

					<div class="row filters-grid">
						<div class="col-md-6">
							<label>Rango de fechas :</label>
							<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
								v-model="search.date" class="date-filter"></date-picker>
						</div>
						<div class="col-md-6">
							<label>Empresa :</label>

							<select v-model="search.company_id" class="form-control" v-if="(authUser.organization_charts_id != 10 || authUser.id==1123 )&& authUser.organization_charts_id != 15">
								<option value=""> Sin empresa </option>
								<option v-for="(company, index) in catalogue.companies_buildings" :value="company.id" :key="index">
									{{ company.name }}</option>
							</select>

							<select v-model="search.company_id" class="form-control" v-else>
								<option value=""> Sin empresa </option>
								<option v-for="(company, index) in catalogue.companies_users" :value="company.id" :key="index">
									{{ company.name }}
								</option>
							</select>
						</div>
						<div class="col-md-6 mt-2" v-if="view==2">
							<label>Socio :</label>
							<select type="text" class="form-control" v-model="search.user_id">
								<option value="">Todos</option>
								<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
									{{ user.name }} {{ user.last_name }}</option>
							</select>
						</div>
						<div class="col-md-6 mt-2" v-if="view==2">
							<label>Tipo de pago</label>
							<select type="text" class="form-control" v-model="search.type_payment_id">
								<option value="">Todos</option>
								<option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
									:value="type_payment.id" :key="index_type_payment">{{ type_payment.name }}</option>
							</select>
						</div>
					</div>
					<div class="col-12">
						<div class="row">
							<div class="col-md-6">
								<button @click="view=1" :class="view == 1 ? 'active' : ''"
									class="btn btn-sm btn-outline-primary">
									Reparto
								</button>
								<button @click="view=2" :class="view == 2 ? 'active' : ''"
									class="btn ml-1 btn-sm btn-outline-primary">
									Socio
								</button>
							</div>
						</div>
						<hr>
					</div>
				</section>
				<section class="table-container results-panel">
					<div class="row">
						<div class="col-md-6">
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item" v-can="'view_created'">
									<a class="nav-link active" @click="search.paid = 0, search.authorized = 1" data-toggle="pill" role="tab"
										aria-selected="true" v-if="this.authUser.profile.permissions.some(permission => permission.permission=='view_created')">Repartos</a>
									<a class="nav-link" @click="search.paid = 0, search.authorized = 1" data-toggle="pill" role="tab"
										aria-selected="false" v-else>Repartos</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="search.paid = 0, search.authorized = 0" data-toggle="pill" role="tab"
										aria-selected="false" v-if="this.authUser.profile.permissions.some(permission => permission.permission=='view_created')">Aprobados</a>
									<a class="nav-link active" @click="search.paid = 0, search.authorized = 0" data-toggle="pill" role="tab"
										aria-selected="true"  v-else>Aprobados</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="search.authorized = 0, search.paid = 1" data-toggle="pill" role="tab"
										aria-selected="false">Pagados</a>
								</li>
							</ul>
						</div>
						<div class="col-md-6">
							<button class="btn btn-outline-success btn-sm mr-2" v-can="'export_share'"
								@click="exportData()">
								<i class="fa fa-file-excel"></i> Exportar
							</button>
							<label>
								<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
									<li class="nav-item">
										<label class="nav-link">Resultados por P&aacute;gina:</label>
									</li>
									<li class="nav-item">
										<a class="nav-link active" @click="per_page = 10" data-toggle="pill" aria-selected="true">10</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" @click="per_page = 20" data-toggle="pill" aria-selected="false">20</a>
									</li>
									<li class="nav-item">
										<a class="nav-link" @click="per_page = 50" data-toggle="pill" aria-selected="false">50</a>
									</li>
								</ul>
							</label>
						</div>
					</div>
					<div class="table-responsive shares-table-wrapper" v-show="view==1">
						<table class="table table-bordered table-hover text-center text-sm shares-table">
							<thead>
								<tr>
									<!-- <th>ID
										<button class="btn btn-xs" @click.prevent="sortPage('id')">
											<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th> -->
									<th class="data-column">Compañía
										<button class="btn btn-xs" @click.prevent="sortPage('name')">
											<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha
										<button class="btn btn-xs" @click.prevent="sortPage('date')">
											<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Monto Reparto
										<button class="btn btn-xs" @click.prevent="sortPage('amount')">
											<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Monto Aprobado
										<button class="btn btn-xs" @click.prevent="sortPage('approved')">
											<i class="fa" :class="order.approved==-1?'fa-minus':(order.approved%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Monto Pagado
										<button class="btn btn-xs" @click.prevent="sortPage('paid')">
											<i class="fa" :class="order.paid==-1?'fa-minus':(order.paid%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="actions-column">Opciones</th>
									<th v-if="paymentConditions()" v-can="'approve_share'" class="text-center check-column">
										<button v-if="Arrauthorized.length<shares_s.length" class="btn btn-sm btn-info" @click.prevent="selectAll">
											<i class="fa-solid fa-check-square"></i>
										</button>
										<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
											<i class="fa-solid fa-square"></i>
										</button>
									</th>
								</tr>
							</thead>
							<tbody v-if="load">
								<tr>
									<td align="center" colspan="6">
										<div class="loading-state">
											<i class="fa-solid fa-circle-notch fa-spin"></i>
											<h5>Cargando repartos</h5>
											<p>Estamos consultando la información.</p>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="shares_s && shares_s.length > 0">
								<tr class="share-row" :class="share.id == selected ? 'selected' : ''" v-for="(share, index) in shares_s" :key="index">
									<!-- <td>
										{{ share.id }}
									</td> -->
									<td class="data-cell">
										<span v-if="share.company">{{ share.company.name }}</span>
										<span v-else> Sin empresa </span>
									</td>
									<td class="date-cell">{{ share.date | toDateTime }}</td>
									<!-- <td>
										<span v-if="share.checks.length == 0">
											Pendiente de Aprobar
										</span>
										<span v-else>
											Aprobada
										</span>
									</td> -->
									<td class="amount-cell">{{ share.amount | toCurrency }}</td>
									<td class="amount-cell amount-payable-cell">{{ share.checks_sum_amount??0 | toCurrency }}</td>
									<td class="paid-cell amount-paid-cell">{{ share.pays_sum_amount??0 | toCurrency }}</td>
									<td class="text-center actions-cell">
										<div class="actions-wrap">
											<button @click="approve(share)" v-can="'approve_share'" v-if="share.checks.length == 0"
												class="btn m-1 btn-outline-success btn-sm">
												<i class="fas fa-check "> </i> Aprobar
											</button>

											<button @click="newShare(share, true)" v-can="'edit_share'"
												v-if="share.checks.length == 0" class="btn m-1 btn-outline-primary btn-sm">
												<i class="fas fa-edit "> </i> Editar
											</button>
											<button @click="newShare(share, false)"
												class="btn m-1 btn-outline-secondary btn-sm">
												<i class="fas fa-eye "> </i> Ver más
											</button>
											<button @click="downloadPDF(share.id)" type="button"
												class="btn btn-sm  m-1 btn-outline-info "
												v-if="authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == share.company_id })"
												>
												<i class="fa-solid fa-eye"></i> Descargar PDF
											</button>
											<button type="button" @click="deleted(share)" v-can="'deleted_share'"
												v-if="share.checks.length == 0" class="btn m-1 btn-outline-danger btn btn-sm ">
												<i class="fa fa-trash"></i> Eliminar
											</button>
										</div>
									</td>
									<th class="text-center" v-if="paymentConditions()" v-can="'approve_share'">
										<input type="checkbox"
											class="form-control form-control-sm" :value="share.id" v-model="Arrauthorized">																		
									</th>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td align="center" colspan="6">Sin resultados.</td>
								</tr>
							</tbody>
							<tfoot v-if="shares_p && shares_p.length > 0 && load == false">
								<tr class="totals-row">
									<!-- <td colspan="3"> -->
									<td colspan="2">
										Total :
									</td>
									<td class="text-right">
										{{ sumdata()[0] | toCurrency }}
									</td>
									<td class="text-right">
										{{ sumdata()[1] | toCurrency }}
									</td>
									<td class="text-right">
										{{ sumdata()[2] | toCurrency }}
									</td>
									<td></td>
								</tr>
							</tfoot>
						</table>
					</div>

					<div class="pagination-wrapper" v-if="shares_s.length">
						<pagination v-model="page" :records="parseInt(shares.length)" :per-page="parseInt(per_page)"
							@paginate="changePage" />
					</div>
					<div class="table-responsive shares-table-wrapper" v-show="view != 1 && search.authorized == 0">
						<table class="table table-bordered table-hover text-center text-sm shares-table">
							<thead>
								<tr>
									<!-- <th>ID
										<button class="btn btn-xs" @click.prevent="sortPage('id')">
											<i class="fa" :class="order.id==-1?'fa-minus':(order.id%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th> -->
									<th class="data-column">Informaci&oacute;n del Pago
										<button class="btn btn-xs" @click.prevent="sortPage('name')">
											<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="amount-column">Monto
										<button class="btn btn-xs" @click.prevent="sortPage('amount')">
											<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
								<!--	<th style="width: 140px;">Por pagar</th> -->
									<th class="amount-column">Pagado
										<button class="btn btn-xs" @click.prevent="sortPage('paid')">
											<i class="fa" :class="order.paid==-1?'fa-minus':(order.paid%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha de aprobación
										<button class="btn btn-xs" @click.prevent="sortPage('approved')">
											<i class="fa" :class="order.approved==-1?'fa-minus':(order.approved%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
								<!--	<th>Fecha de creación</th> -->
									<th class="date-column">Fecha de reparto
										<button class="btn btn-xs" @click.prevent="sortPage('date')">
											<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="actions-column text-center">Opciones</th>
									<th v-can="'add_pays_fast'" v-if="paymentConditions()" class="text-center check-column">
										<button v-if="Arrauthorized.length<checks_s.filter(c=>c.type_payment_id!=6).length" class="btn btn-sm btn-info" @click.prevent="selectAll">
											<i class="fa-solid fa-check-square"></i>
										</button>
										<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
											<i class="fa-solid fa-square"></i>
										</button>
									</th>
									<th v-can="'add_pays_fast'" v-if="paymentConditionsCheck()" class="text-center check-column">
										<button v-if="Arrauthorized.length<checks_s.length" class="btn btn-sm btn-info" @click.prevent="selectAll">
											<i class="fa-solid fa-check-square"></i>
										</button>
										<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
											<i class="fa-solid fa-square"></i>
										</button>
									</th>
								</tr>
							</thead>
							<tbody v-if="load">
								<tr>
									<td align="center" colspan="6">
										<div class="loading-state">
											<i class="fa-solid fa-circle-notch fa-spin"></i>
											<h5>Cargando pagos aprobados</h5>
											<p>Estamos consultando la información.</p>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="checks_s.length > 0">
								<tr class="check-row" :class="check.id == selected ? 'selected' : ''" v-for="(check, index) in checks_s" :key="index">
									<!-- <td>{{ check.id }}</td> -->
									<td class="data-cell text-left">
										<!-- Tipo -->
										<!-- Nomina -->
										<span v-if="check.share_id">
											<strong>Socio : </strong>
											<span v-if="check.user&&(authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == check.share.company_id }))">{{check.user.name}} {{check.user.last_name}}</span>
											<span v-else-if="check.user">XXXXXXXXXXX</span>
											<span v-else>Sin usuario</span>
											<span v-if="(user=check.share.users.filter((user, index) => { return (user.id == check.user_id)})[0]) && (bank = check.user.bank_accounts.filter((bank, index) => { return (user.pivot.bank_account_id == bank.id)})[0])">
											<br>
												<strong>Cuenta bancaria: </strong>
												<span v-if="authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == check.share.company_id })">
													{{bank.account_number }} |
													<a class="btn btn-info btn-sm" target="_blank"
														v-if="bank.file"
														:href="`${globalUrlFiles}${bank.file}`">
														<i class="fa-regular fa-file-pdf"></i> Ver caratula de banco
													</a>
													<small v-else class="btn_now badge badge-secondary"> Sin caratula de banco</small>
												</span>
												<span v-else>XXXXXXXXXXX</span>
											</span>
											<!-- <span v-else>No Aplica</span> -->
											<br>
											<strong>Compañía : </strong>
											{{ check.share.company.name }}<br>
											<strong>Fecha : </strong>
											{{ check.share.date | toDateTime }}<br>
											
											<strong>Tipo de Pago : </strong>
											<span v-if="check.type_payment">
												{{ check.type_payment.name }}
											</span>
											<span v-else>Sin tipo</span>
											<br>
											<strong>Monto : </strong>
											{{ check.share.amount | toCurrency }}<br>
											<strong v-if="check.pay && check.pay.length!=0">Pagos:</strong>
											<span v-for="(pay, index) in check.pay" :key="index">
												{{ pay.date | toDateTime }} - {{ pay.amount | toCurrency }}<br>
											</span>
											<span v-if="check.pay && check.pay.length!=0&&check.type_payment_id==6">
												<strong >Cheques:</strong>
												<span v-for="(pay, index) in check.pay" :key="index">
													{{ pay.checkbook?pay.checkbook.name:'' }} - Folio: {{ pay.folio }}<br>
												</span>
											</span>
											<span v-if="search.paid==0 && check.folio_prev && check.type_payment_id==6">
												<strong >Cheque Guardado:</strong>
													{{ check.checkbook?check.checkbook.name:'' }} - Folio: {{ check.folio_prev }}<br>
											</span>
										</span>
									</td>
									<td class="amount-cell text-right">
										{{ (check.amount + check.credit) | toCurrency }}
									</td>
								<!--	<td class="text-right">
										<strong style="font-weight: 900;">{{ check.amount_payable | toCurrency }}</strong>
									</td> -->
									<td class="paid-cell amount-paid-cell text-right">
										{{ check.sum_pays | toCurrency }}
									</td>
									<td class="date-cell">
										<span v-if="check.user_approved"> {{ check.authorization_date | toDateTime }} </span>
										<span v-else>Sin Fecha</span>
									</td>
								<!--	<td>
										{{ check.created_at | toDateTime }}
									</td> -->
									<td class="date-cell">
										<span v-if="check.share">
											{{ check.share.date | toDateTime }}
										</span>
										<span v-else>
											S/F
										</span>

									</td>
									<td class="actions-cell text-center">
										<div class="actions-wrap">
											<!-- <button v-if="check.share&&check.type_payment && check.type_payment.name=='Dispersión'&&(authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == check.share.company_id }))" @click="showShare(check.share)"
												class="btn btn-outline-secondary m-1 btn-sm">
												<i class="fa-solid fa-receipt mr-1"></i> Ver reparto
											</button> -->

											<div class="d-inline" v-if="check.pay && check.pay.length == 0">
												<button v-if="check.share_id && check.type_payment_id != 6"
													@click="formDataPayFast(check)"
													class="btn btn-outline-secondary m-1 btn-sm">
													<i class="fa-solid fa-receipt mr-1"></i> Pago rápido
												</button>

												<button v-if="check.share_id && check.type_payment_id == 6"
													@click="formDataPaysFastCheckbook(check)"
													class="btn btn-outline-secondary m-1 btn-sm">
													<i class="fa-solid fa-receipt mr-1"></i> Pago rápido cheque
												</button>
											</div>

											<button type="button" v-if="check.share_id && search.paid == 0" @click="deleted(check)"
												v-can="'deleted_checks'" class="btn-outline-danger btn m-1 btn-sm ">
												<i class="fa fa-trash"></i> Desaprobar
											</button>
											<button @click="formListPays(check)" class="btn m-1 btn-sm btn-outline-warning">
												<i class="fa-solid fa-hand-holding-dollar mr-1"> </i>
												<span>Ver pago</span>
											</button>
											<div class="d-inline" v-if="check.share_id && search.paid != 0">
												<button v-for="(pay, index) in check.pay" :key="index" @click="getVoucher(pay.id)"
													class="btn btn-outline-info m-1 btn-sm">
													<i class="fa-solid fa-file-pdf mr-1"></i> Aviso de pago
												</button>
											</div>
										</div>
									</td>
									<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditions()">
										<input type="checkbox" :disabled="check.type_payment_id == 6"
											class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">																		
									</th>
									<th class="text-center" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
										<input type="checkbox" :disabled="check.type_payment_id != 6"
											class="form-control form-control-sm" :value="check.id" v-model="Arrauthorized">
										<br>
										<span v-if="check.checkbook" class="badge badge-info">
										{{ check.checkbook.name }}
										<br>-<br>
										{{ check.folio_prev }}
										</span>
									</th>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td align="center" colspan="6" class="table-state">
										<i class="fa-regular fa-folder-open"></i>
										<h5>Sin resultados</h5>
										<p>Prueba cambiando o eliminando alguno de los filtros.</p>
									</td>
								</tr>
							</tbody>
							<tfoot v-if="checks_s.length > 0 && load == false">
								<tr class="totals-row">
									<!-- <td colspan="2"> -->
									<td>
										Total :
									</td>
									<td class="text-right">
										{{ sumdata()[0] | toCurrency }}
									</td>
									<!-- <td class="text-right">
										{{ sumdata()[1] | toCurrency }}
									</td> -->
									<td class="text-right">
										{{ sumdata()[2] | toCurrency }}
									</td>
									<td colspan="3"></td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="pagination-wrapper" v-if="checks_p.length">
						<pagination v-model="page" :records="checks.length" :per-page="per_page"
						@paginate="changePage" />
					</div>
					<div class="table-responsive shares-table-wrapper" v-show="view != 1 && search.authorized != 0">
						<table class="table table-bordered table-hover text-center text-sm shares-table">
							<thead>
								<tr>
									<th  class="data-column">Informaci&oacute;n del reparto
										<button class="btn btn-xs" @click.prevent="sortPage('name')">
											<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th  class="amount-column">Monto
										<button class="btn btn-xs" @click.prevent="sortPage('amount')">
											<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th  class="amount-column">Retenci&oacute;n
										<button class="btn btn-xs" @click.prevent="sortPage('retention')">
											<i class="fa" :class="order.retention==-1?'fa-minus':(order.retention%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="date-column">Fecha de reparto
										<button class="btn btn-xs" @click.prevent="sortPage('date')">
											<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
										</button>
									</th>
									<th class="actions-column text-center">Opciones</th>
									<th v-if="paymentConditions()" class="text-center check-column">
										<button v-if="Arrauthorized.length<partners_s.length" class="btn btn-sm btn-info" @click.prevent="selectAll">
											<i class="fa-solid fa-check-square"></i>
										</button>
										<button v-else class="btn btn-sm btn-info" @click.prevent="deselectAll">
											<i class="fa-solid fa-square"></i>
										</button>
									</th>
								</tr>
							</thead>
							<tbody v-if="load">
								<tr>
									<td align="center" colspan="5">
										<div class="loading-state">
											<i class="fa-solid fa-circle-notch fa-spin"></i>
											<h5>Cargando repartos</h5>
											<p>Estamos consultando la información.</p>
										</div>
									</td>
								</tr>
							</tbody>
							<tbody v-else-if="partners_s.length>0">
								<tr class="partner-row" :class="partner.id == selected ? 'selected' : ''" v-for="(partner, index) in partners_s" :key="index">
									<td class="data-cell text-left">
										<span>
											<strong>Socio : </strong>
											<span v-if="partner.share&&(authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == partner.share.company_id }))">{{partner.user.name}} {{partner.user.last_name}}</span>
											<span v-else>XXXXXXXXXXX</span>
											<span v-if="bank = partner.user.bank_accounts.filter((bank, index) => { return (partner.bank_account_id == bank.id)})[0]">
											<br>
												<strong>Cuenta bancaria: </strong>
												<span v-if="authUser.organization_charts_id==1 || authUser.organization_charts_id==4 || authUser.id==1123 || authUser.companies.some((spec, index) => { return spec.id == partner.share.company_id })">{{bank.account_number }}</span>
												<span v-else>XXXXXXXXXXX</span>
											</span>
											<!-- <span v-else>No Aplica</span> -->
											<br>
											<strong>Compañía : </strong>
											{{ partner.share.company.name }}<br>
											<strong>Fecha : </strong>
											{{ partner.share.date | toDateTime }}<br>
											
											<strong>Tipo de Pago : </strong>
											<span v-if="partner.type_payment">
												{{ partner.type_payment.name }}
											</span>
											<span v-else>Sin tipo</span>
											<br>
											<strong>Monto Reparto : </strong>
											{{ partner.share.amount | toCurrency }}<br>
										</span>
									</td>
									<td class="amount-cell text-right">
										{{ (partner.amount) | toCurrency }}
									</td>
									<td class="amount-cell text-right">
										{{ partner.retention | toCurrency }}
									</td>
									<td class="date-cell">
										<span v-if="partner.share">
											{{ partner.share.date | toDateTime }}
										</span>
										<span v-else>
											S/F
										</span>
									</td>
									<td class="text-center actions-cell">
										<div class="actions-wrap">
											<button @click="approve(partner)" v-can="'approve_share'"
												class="btn m-1 btn-outline-success btn-sm">
												<i class="fas fa-check "> </i> Aprobar
											</button>
											<button @click="newShare(partner.share, true)" v-can="'edit_share'"
												class="btn m-1 btn-outline-primary btn-sm">
												<i class="fas fa-edit "> </i> Editar
											</button>
											<button @click="newShare(partner.share, false)"
												class="btn m-1 btn-outline-secondary btn-sm">
												<i class="fas fa-eye "> </i> Ver más
											</button>
										</div>
									</td>
									<th class="text-center" v-if="paymentConditions()">
										<input type="checkbox"
											class="form-control form-control-sm" :value="{user_id:partner.user_id,share_id:partner.share_id}" v-model="Arrauthorized">
									</th>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td align="center" colspan="5">
										<div class="empty-state">
											<i class="fa-regular fa-folder-open"></i>
											<h5>Sin resultados</h5>
											<p>Prueba cambiando o eliminando alguno de los filtros.</p>
										</div>
									</td>
								</tr>
							</tbody>
							<tfoot v-if="partners_s.length > 0 && load == false">
								<tr class="totals-row">
									<td>
										Total :
									</td>
									<td class="text-right">
										{{ sumdata()[0] | toCurrency }}
									</td>
									<td class="text-right">
										{{ sumdata()[1] | toCurrency }}
									</td>
									<td colspan="2"></td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="pagination-wrapper" v-if="partners_s.length">
						<pagination v-if="partners.length" v-model="page" :records="partners?partners.length:0" :per-page="per_page"
							@paginate="changePage" />
					</div>
				</section>
				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditions()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" :disabled="Arrauthorized.length==0"
							v-if="!sendGroup && view == 2 && search.authorized!=1" @click="formDataPaysFastGroup()">
							<i class="fa-solid fa-list-check"></i> Pago rápido seleccionado
						</button>
						<button class="btn btn-outline-info" :disabled="Arrauthorized.length==0"
						v-else-if="!sendGroup && view == 1 || search.authorized==1" @click="formDataApproveGroup()">
							<i class="fa-solid fa-list-check"></i>Aprobar seleccionados
						</button>
						<button class="btn btn-outline-info" disabled="true" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

				<div class="row mt-3" v-can="'add_pays_fast'" v-if="paymentConditionsCheck()">
					<div class="col-12 text-right">
						<button class="btn btn-outline-info" :disabled="Arrauthorized.length==0"
							v-if="!sendGroup && view == 2" @click="formDataPaysFastGroupCheck()">
							<i class="fa-solid fa-list-check"></i> Pago de cheque agrupado
						</button>
						<button class="btn btn-outline-info" disabled="true" v-else>
							<i class="fa-solid fa-circle-notch fa-spin"></i> Pagando
						</button>
					</div>
				</div>

			</div>
		</div>
		<ModalFormComponent :prop_edit="editShare" />
		<ModalTableComponentPays :prop_edit="false" />
		<ModalPayCheckbookFastComponent />
		<ModalPayGroupCheckbookFastComponent />
		<ModalFormRulesComponent />
		<ModalFormTaxesComponent />
		<ModalDownloadFileComponent />
		<LoadPay />
	</div>
</template>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	opacity: 0;
}

.btn-xs {
  padding: 0.125rem 0.25rem;
  font-size: 0.70rem;
  line-height: 1.2;
}
</style>
